import script from "./DsMultipleSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./DsMultipleSelect.vue?vue&type=script&setup=true&lang=ts"

import "./DsMultipleSelect.vue?vue&type=style&index=0&id=1cc07a26&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc07a26"]])

export default __exports__